import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '课程名称',
      placeholder: '请输入课程名称',
      rules: { required: true, message: '课程名称是必传的', trigger: 'blur' }
    },
    {
      field: 'enName',
      type: 'input',
      label: '课程缩写',
      placeholder: '请输入课程缩写',
      rules: {
        required: true,
        message: '课程缩写是必传的',
        trigger: 'blur'
      }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
